export const LOAD = 'ethstats/transactionsHistory/LOAD';
export const LOAD_SUCCESS = 'ethstats/transactionsHistory/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/transactionsHistory/LOAD_FAIL';
